import { apiGet } from '../config'
import { API_ROUTES } from '../routes'
import { Product } from '../typing'
import { useQueryHook } from './queryHook'

export const useGetDataProduct = (id: string) => {
  const path = API_ROUTES.PRODUCT_GET

  const queryObject = useQueryHook({
    key: [path, id],
    fetcherFunction: async () => {
      const { data } = await apiGet<object, Product>({ path, params: { productId: id } })

      return data
    },
  })

  if (queryObject.isLoading || queryObject.isError) {
    return {
      ...queryObject,
      data: null,
    }
  }

  return {
    ...queryObject,
    data: queryObject.data as Product | null,
  }
}
